import { types, Instance } from 'mobx-state-tree';
import { modelWithCRUD } from './utils/modelWithCRUD';

export const CurrencyRate = types.model({
  id: types.union(types.identifierNumber, types.identifier),
  currency: types.string,
  rate: types.number,
  label: types.string,
});

export const CurrencyStore = modelWithCRUD(
  'currencies',
  CurrencyRate,
  false
).named('CurrencyStore');

export interface ICurrencyRate extends Instance<typeof CurrencyRate> {}
